/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';

import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import pt from 'react-intl/locale-data/pt';
import configureStore from './store/configureStore';
import configureAxios from './utils/configureAxios';

import { unregister } from './registerServiceWorker';

import { flattenMessages } from './i18n/utils';

import App from './App';

import en_US from './i18n/en_US.json';
import pt_BR from './i18n/pt_BR.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-table/react-table.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './assets/styles/css/index.css';
import './assets/styles/css/configUser.css';
import './polyfills';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

// Configure Axios (Global Params, Interceptors, etc..)
configureAxios(history);

const locale = navigator.language.split(/[-_]/)[0]; // language without region code
addLocaleData([...en, ...pt]);
const messages = { en: en_US, pt: pt_BR };

const rootElement = document.getElementById('root');

ReactDOM.render(
    <IntlProvider
        locale={locale}
        messages={messages[locale] && flattenMessages(messages[locale])}
    >
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </IntlProvider>,
    rootElement,
);

unregister(); // unregistering service worker for cache cleaning
